import { useEffect, useState } from 'react'
import { useAccountContext } from 'src/components/account/context'
import { addressService } from 'src/services/addressService'

export function usePostalCodeDefaultAddress(params: {
  showModal: boolean
  orderFormId: string
}) {
  const { showModal, orderFormId } = params
  const [defaultAddressId, setDefaultAddressId] = useState<string | null>(null)
  const { isLoggedIn } = useAccountContext()

  useEffect(() => {
    if (!showModal || !orderFormId || !isLoggedIn) {
      setDefaultAddressId(null)

      return
    }

    let cancelled = false

    const fetchDefaultAddress = async () => {
      try {
        const defaultAddress = await addressService.getDefaultAddress({
          orderFormId,
        })

        if (!cancelled) {
          setDefaultAddressId(defaultAddress?.addressId ?? null)
        }
      } catch {
        if (!cancelled) {
          setDefaultAddressId(null)
        }
      }
    }

    fetchDefaultAddress()

    return () => {
      cancelled = true
    }
  }, [orderFormId, showModal, isLoggedIn])

  return {
    defaultAddressId,
    setDefaultAddressId,
  }
}
